// ========================================
// Widget: RRHH — Plantilla por tipo de pago
// Personal en activo con sueldo fijo, por horas y autónomo, y aviso de quien
// cobra por horas sin tarifa (su coste estimado sale a cero).
// ========================================

window.DashboardWidgets = window.DashboardWidgets || {};
window.DashboardWidgets.rrhh = window.DashboardWidgets.rrhh || {};

window.DashboardWidgets.rrhh.plantillaTipos = function(ctx) {
    const { payTypes = { fixed: 0, hourly: 0, freelance: 0, noRate: 0 } } = ctx;
    const total = payTypes.fixed + payTypes.hourly + (payTypes.freelance || 0);
    const pct = n => total ? `${(n / total * 100).toFixed(1)}%` : '0%';
    const parts = [['Sueldo fijo', payTypes.fixed, 'var(--dnr-teal-700)'], ['Por horas', payTypes.hourly, 'var(--dnr-teal-400)'], ['Autónomo', payTypes.freelance || 0, 'var(--dnr-amber-500)']];
    const inner = `
        <div class="rp-card-head">
            <h2 class="rp-card-title">Plantilla</h2>
            <span class="rp-muted">${total} en activo</span>
        </div>
        <div class="rp-split" role="img" aria-label="${parts.map(([label, n]) => `${label}: ${n}`).join(', ')}">
            ${parts.map(([, n, color]) => `<span style="width: ${pct(n)}; background: ${color}"></span>`).join('')}
        </div>
        <div class="rp-split-list">
            ${parts.map(([label, n, color]) => `<span><span><span class="rp-swatch" style="background: ${color}"></span>${label}</span><strong>${n}</strong></span>`).join('')}
        </div>
        ${payTypes.noRate ? `<span class="rp-muted" style="border-top: 1px solid var(--dnr-surface-sunken); padding-top: 0.6rem;">${payTypes.noRate} ${payTypes.noRate === 1 ? 'persona por horas no tiene' : 'personas por horas no tienen'} tarifa: <button type="button" class="rp-card-link" ${UIEvents.attr("click", function(event,captured){App.navigate('profesores/activos');}, [])}>revisarlas</button></span>` : ''}`;
    return window.DashboardWidgets.rrhh.card(ctx, inner);
};
